/* eslint-disable */
import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Grid,
  Card,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  InputAdornment,
  IconButton,
} from '@mui/material';
import {
  LocalizationProvider,
  MobileDatePicker,
  MobileTimePicker,
} from '@mui/x-date-pickers';
import { useNavigate } from 'react-router-dom';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ClearIcon from '@mui/icons-material/Clear';
import axios from 'axios';
import api from '../../utils/functions/api';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Loading from '../Loading';


const bankOptions = [
  {
    label: 'ธนาคารกสิกรไทย',
    value: 'KBANK',
    icon: require('../../assets/images/kbanklogo.png'),
  },
  {
    label: 'ธนาคารกรุงไทย',
    value: 'KTB',
    icon: require('../../assets/images/ktblogo.png'),
  },
  {
    label: 'ธนาคารออมสิน',
    value: 'GSB',
    icon: require('../../assets/images/gsblogo.png'),
  },
  {
    label: 'ธนาคารทหารไทยธนชาต',
    value: 'TTB',
    icon: require('../../assets/images/ttblogo.png'),
  },
  {
    label: 'ธนาคารกรุงศรีอยุธยา',
    value: 'BAY',
    icon: require('../../assets/images/baylogo.png'),
  },
  {
    label: 'ธนาคารกรุงเทพ',
    value: 'BBL',
    icon: require('../../assets/images/bbllogo.png'),
  },
  {
    label: 'ธนาคารไทยพาณิชย์',
    value: 'SCB',
    icon: require('../../assets/images/scblogo.png'),
  },
  {
    label: 'ธนาคารซีไอเอ็มบีไทย',
    value: 'CIMBT',
    icon: require('../../assets/images/cimbtlogo.png'),
  },
  {
    label: 'ธนาคารยูโอบี',
    value: 'UOBT',
    icon: require('../../assets/images/uobtlogo.png'),
  },
  {
    label: 'ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร',
    value: 'BAAC',
    icon: require('../../assets/images/baaclogo.png'),
  },
  {
    label: 'ธนาคารแลนด์แอนด์เฮ้าส์',
    value: 'LHFG',
    icon: require('../../assets/images/LHB_Logo_short.svg.png'),
  },
];

function FinalConfirmationPopup({ open, onClose, language, isLoading }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { borderRadius: '15px', width: '400px' } }}
    >
            <Loading isLoading={isLoading} />
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 'bold',
            fontSize: '24px',
            marginTop: '20px',
          }}
        >
          <CheckCircleOutlineIcon
            sx={{ fontSize: 90, color: 'green', marginBottom: '10px' }}
          />
          {language === 'TH' ? 'บันทึกสำเร็จ !' : 'Save Successful!'}
        </Box>
      </DialogContent>
      <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box
          sx={{
            width: '25%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            border: '1px solid',
            borderRadius: '9px',
            color: '#45A6F5',
            backgroundColor: 'transparent',
            '&:hover': { backgroundColor: '#E3F3FF' },
            margin: 'auto',
          }}
        >
          <Button onClick={onClose}>
            {language === 'TH' ? 'ปิด' : 'Close'}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}

function ConfirmationPopup({
  open,
  onClose,
  onConfirm,
  amount,
  bank,
  transferDate,
  transferTime,
  images,
  language,
  isLoading
}) {
  const labels = {
    amount:
      language === 'TH' ? 'จำนวนเงินที่ชำระ (บาท)' : 'Payment Amount (THB)',
    bank: language === 'TH' ? 'โอนจากธนาคาร' : 'Transfer from Bank',
    date: language === 'TH' ? 'วันที่โอน' : 'Transfer Date',
    time: language === 'TH' ? 'เวลาที่โอน' : 'Transfer Time',
    proof: language === 'TH' ? 'หลักฐาน' : 'Proof',
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { borderRadius: '15px' } }}
    >
            <Loading isLoading={isLoading} />
      <DialogTitle>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            fontWeight: 'bold',
            fontSize: '20px',
            marginTop: '20px',
            marginLeft: '10px',
          }}
        >
          {language === 'TH' ? 'ยืนยันข้อมูล' : 'Confirm Information'}
        </Box>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ width: '100%' }}>
          {[
            { label: labels.amount, value: amount },
            { label: labels.bank, value: bank },
            { label: labels.date, value: transferDate },
            { label: labels.time, value: transferTime },
          ].map(({ label, value }) => (
            <Grid item xs={12} key={label}>
              <div
                style={{
                  fontSize: '17px',
                  fontWeight: 'bold',
                  marginLeft: '20px',
                }}
              >
                {label} :
              </div>
              <div
                style={{
                  position: 'relative',
                  backgroundColor: '#f0f0f0',
                  padding: '17px',
                  borderRadius: '8px',
                  marginLeft: '20px',
                  marginTop: '6px',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    left: '20px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    fontSize: '17px',
                  }}
                >
                  {value}
                </div>
              </div>
            </Grid>
          ))}
          <Grid item xs={12}>
            <div
              style={{
                fontSize: '17px',
                fontWeight: 'bold',
                marginLeft: '20px',
              }}
            >
              {labels.proof} :
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            container
            justifyContent="center"
            alignItems="center"
            sx={{ display: 'flex', justifyContent: 'center' }}
          >
            {images.length > 0 &&
              images.map((image, index) => (
                <img
                  key={index}
                  src={URL.createObjectURL(image)}
                  alt={`Proof ${index + 1}`}
                  style={{
                    width: '100%',
                    height: 'auto',
                    maxWidth: '300px',
                    borderRadius: '8px',
                    marginBottom: '10px',
                  }}
                />
              ))}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            gap: 2,
            marginBottom: '20px',
            marginTop: '20px',
          }}
        >
          <Button
            onClick={onClose}
            sx={{
              width: '100px',
              border: '1px solid',
              color: '#FC3A3A',
              backgroundColor: 'transparent',
              '&:hover': { backgroundColor: 'rgba(252, 58, 58, 0.1)' },
            }}
          >
            {language === 'TH' ? 'ยกเลิก' : 'Cancel'}
          </Button>
          <Button
            onClick={onConfirm}
            sx={{
              width: '100px',
              border: '1px solid',
              color: '#51D245',
              backgroundColor: 'transparent',
              '&:hover': { backgroundColor: 'rgba(81, 210, 69, 0.1)' },
            }}
          >
            {language === 'TH' ? 'ยืนยัน' : 'Confirm'}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}

function BankTransferPopup({
  open,
  onClose,
  tokens,
  etaxData,
  bankImage,
  nameAccount,
  accountNumber,
  totalAmount,
  language,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const checkAmount = parseFloat(totalAmount.replace(/,/g, '')); // Remove commas and convert to number
  const navigate = useNavigate();
  const [date, setDate] = useState(new Date());
  const [time, setTime] = useState(new Date());
  const [amount, setAmount] = useState('');
  const [bank, setBank] = useState('');
  const [images, setImages] = useState([]);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [finalConfirmationOpen, setFinalConfirmationOpen] = useState(false);
  const [amountError, setAmountError] = useState('');
  const [bankError, setBankError] = useState('');
  const [imageError, setImageError] = useState('');
  const [uploadRefID, setUploadRefID] = useState('');
  const [intervalId, setIntervalId] = useState(null);

  useEffect(() => {
    if (open) {
      resetFields();
    }
  }, [open]);

  useEffect(() => {
    if (uploadRefID) {
      const id = startPaymentCheck(uploadRefID);
      setIntervalId(id);
    }
  }, [uploadRefID]);

  const resetFields = () => {
    setDate(new Date());
    setTime(new Date());
    setAmount('');
    setBank('');
    setImages([]);
    setAmountError('');
    setBankError('');
    setImageError('');
  };

  const startPaymentCheck = (refID) => {
    return setInterval(() => {
      checkPaymentStatusAndHandleResponse(refID);
    }, 3000);
  };

  const handleConfirmationOpen = () => {
    if (validateFields()) {
      // onClose();
      setConfirmationOpen(true);
    }
  };

  const validateFields = () => {
    let hasError = false;

    if (!amount) {
      setAmountError(
        language === 'TH' ? 'กรุณากรอกจำนวนเงิน' : 'Please enter the amount',
      );
      hasError = true;
    } else if (parseFloat(amount.replace(/,/g, '')) !== checkAmount) {
      setAmountError(
        language === 'TH'
          ? 'จำนวนเงินไม่ตรงกับยอดที่ต้องชำระ'
          : 'The amount does not match the payable amount',
      );
      hasError = true;
    } else {
      setAmountError('');
    }

    if (!bank) {
      setBankError(language === 'TH' ? 'เลือกธนาคาร' : 'Please select a bank');
      hasError = true;
    } else {
      setBankError('');
    }

    if (images.length === 0) {
      setImageError(
        language === 'TH'
          ? 'กรุณาอัพโหลดไฟล์รูป'
          : 'Please upload an image file',
      );
      hasError = true;
    } else {
      setImageError('');
    }

    return !hasError;
  };

  const handleFinalConfirmationOpen = () => {
    // setConfirmationOpen(false);
    saveDataToServer();
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    const validFiles = files.filter((file) =>
      ['image/png', 'image/jpeg', 'image/gif'].includes(file.type),
    );

    if (validFiles.length > 0) {
      const resizedImagesPromises = validFiles.map((file) =>
        resizeImage(file, 1000),
      );
      Promise.all(resizedImagesPromises).then((resizedImages) => {
        setImages((prevImages) => [...prevImages, ...resizedImages]);
        setImageError('');
      });
    } else {
      setImageError(
        language === 'TH'
          ? 'ไฟล์ที่อัพโหลดต้องเป็นรูปภาพ (.png, .jpeg, .gif) เท่านั้น'
          : 'Uploaded files must be images (.png, .jpeg, .gif) only',
      );
    }
  };

  const handleRemoveImage = (index) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  const resizeImage = (file, maxSize) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          let width = img.width;
          let height = img.height;
          if (width > height) {
            if (width > maxSize) {
              height *= maxSize / width;
              width = maxSize;
            }
          } else {
            if (height > maxSize) {
              width *= maxSize / height;
              height = maxSize;
            }
          }
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);
          const dataUrl = canvas.toDataURL('image/jpeg', 0.8);
          resolve(dataUrlToFile(dataUrl, file.name));
        };
      };
      reader.readAsDataURL(file);
    });
  };

  const dataUrlToFile = (dataUrl, filename) => {
    const arr = dataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  const formattedDate = date.toLocaleDateString('th-TH', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
  const formattedTime = time.toLocaleTimeString('th-TH', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

  const saveDataToServer = async () => {
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append('source', 'UP');
      images.forEach((image) => {
        formData.append(`image`, image);
      });
      formData.append('userpayamount', amount);
      const selectedBank = bankOptions.find((b) => b.label === bank);
      formData.append('bank', selectedBank.value);
      formData.append('datepay', formattedDate.replace(/-/g, ''));
      formData.append('timepay', formattedTime.replace(/:/g, ''));
      const eTaxData2 = {
        BUYER_NAME: etaxData?.name,
        BUYER_TAX_ID_TYPE: etaxData?.taxpayerType,
        BUYER_TAX_ID: etaxData?.taxId,
        BUYER_BRANCH_ID: etaxData?.branchCode,
        BUYER_POST_CODE: etaxData?.postalCode,
        BUYER_ADDRESS_LINE1: etaxData?.address,
        BUYER_ADDRESS_LINE2: etaxData?.address2,
      };
      for (const key in eTaxData2) {
        formData.append(key, eTaxData2[key]);
      }

      const response = await api.post(
        `${process.env.REACT_APP_APIHOST}/createpayment/banktransfer`,
        formData,
        { headers: { Authorization: tokens } },
      );
      setIsLoading(false);
      const refID = response.data.uploadRefID;
      if (response.data.status === 'pending' && response.data.company_callback) {
        navigate(
          `/transactionResult?status=pending&urlPDF=${encodeURIComponent(
            response.data.eTaxPDF,
          )}`,
        );
        setUploadRefID(refID);
      } else if (response.data.status === 'pending' && !response.data.company_callback) {
        navigate(
          `/transactionResult?status=pending&urlPDF=${encodeURIComponent(
            response.data.eTaxPDF,
          )}`,
        );
        setUploadRefID(refID);
      } else if (response.data.status === 'cancel' && response.data.company_callback) {
        navigate(
          `/transactionResult?status=cancel&urlPDF=${encodeURIComponent(
            response.data.eTaxPDF,
          )}`,
        );
      } else if (response.data.status === 'cancel' && !response.data.company_callback) {
        navigate(
          `/transactionResult?status=cancel&urlPDF=${encodeURIComponent(
            response.data.eTaxPDF,
          )}`,
        );
      } else if (response.data.status === 'success' && response.data.company_callback) {
        navigate(
          `/transactionResult?status=success&urlPDF=${encodeURIComponent(
            response.data.eTaxPDF,
          )}`,
        );
      } else if (response.data.status === 'success' && !response.data.company_callback) {
        navigate(
          `/transactionResult?status=success&urlPDF=${encodeURIComponent(
            response.data.eTaxPDF,
          )}`,
        );
      } else {
        setUploadRefID(refID);
        setFinalConfirmationOpen(true);
      }
      
    } catch (error) {
      alert(error.response?.data?.message || error.message);
    }
  };

  const checkPaymentStatusAndHandleResponse = async (refID) => {
    try {
      const response = await api.get(
        `${process.env.REACT_APP_APIHOST}/check_callback`,
        { headers: { Authorization: tokens, sub: refID } },
      );
      if (response.status === 200) {
        const { rmsg, status, tagUrl, tagInput } = response.data;
        if (rmsg === 'pending') {
          navigate(`/transactionResult?status=${rmsg}`);
        }
        if (rmsg === 'cancel') {
          clearInterval(intervalId); // Stop the interval if the payment is canceled
          navigate(`/transactionResult?status=${rmsg}`);
        }
        if (rmsg === 'success') {
          clearInterval(intervalId); // Stop the interval if the payment is successful
          if (status === 'call merchant') {
            submitFormToMerchant(tagUrl, tagInput);
          } else if (status === 'call merchant jwt') {
            clearInterval(intervalId);
            submitFormToMerchant(tagUrl, tagInput);
          } else if (status === 'do not call merchant') {
            const etaxResponse = await api.post(
              `${process.env.REACT_APP_APIHOST}/etax/signandgetdocument`,
              { paymentRef: refID },
            );
            const data2 = etaxResponse.data || '';
            if (data2.status === 'OK') {
              const urlPDF = data2.pdfURL;
              window.location.replace(
                `/transactionResult?status=${rmsg}&urlPDF=${encodeURIComponent(
                  urlPDF || '',
                )}`,
              );
            } else {
              window.location.replace(`/transactionResult?status=${rmsg}`);
            }
          }
        }
      }
    } catch (error) {
      console.error('Error during combined API call:', error);
    }
  };

  const submitFormToMerchant = (tagUrl, tagInput) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(tagInput, 'text/html');
    const inputs = doc.querySelectorAll('input');
    const form = document.createElement('form');
    form.action = tagUrl;
    form.method = 'POST';
    form.style.display = 'none';
    inputs.forEach((input) => {
      const inputElement = document.createElement('input');
      inputElement.type = 'hidden';
      inputElement.name = input.name;
      inputElement.value = input.value;
      form.appendChild(inputElement);
    });
    document.body.appendChild(form);
    form.submit();
  };

  return (
    <>
          <Loading isLoading={isLoading} />
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{ sx: { borderRadius: '15px', width: '900px' } }}
      >
        <DialogTitle>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              fontWeight: 'bold',
              fontSize: '20px',
              marginTop: '20px',
              marginLeft: '20px',
            }}
          >
            {language === 'TH'
              ? 'ชำระเงินผ่าน Bank Transfer'
              : 'Pay via Bank Transfer'}
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginRight: {
                xs: '0px',
                md: '70px',
              },
            }}
          >
            <Grid item xs={12} sm={8} md={6} lg={4}>
              <Card
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '16px',
                  marginTop: '20px',
                  padding: '20px',
                  boxShadow: 2,
                  width: {
                    xs: '100%', // ขนาดสำหรับมือถือ
                    sm: '100%', // ขนาดสำหรับแท็บเล็ต
                    md: '120%', // ขนาดสำหรับเว็บ
                    lg: '130%', // ขนาดสำหรับหน้าจอใหญ่
                  },
                  backgroundColor: '#F5F5F5',
                }}
              >
                <img
                  src={`data:image/png;base64,${bankImage}`}
                  alt="KTB"
                  style={{
                    width: '200px',
                    marginTop: '10px',
                    marginBottom: '20px',
                  }}
                />
                <Typography sx={{ fontWeight: 'bold', fontSize: '16px' }}>
                  {language === 'TH' ? 'ชื่อบัญชี' : 'Account Name'} :{' '}
                  {nameAccount}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 'bold',
                    fontSize: '16px',
                    marginBottom: '10px',
                  }}
                >
                  {language === 'TH' ? 'เลขบัญชี' : 'Account Number'} :{' '}
                  {accountNumber}
                </Typography>
              </Card>
            </Grid>
          </Box>

          <Grid container spacing={2} sx={{ width: '100%', marginTop: '20px' }}>
            <Grid item xs={12} md={6}>
              <TextField
                label={
                  language === 'TH'
                    ? 'กรุณากรอกจำนวนเงิน'
                    : 'Please enter the amount'
                }
                variant="outlined"
                type="number"
                size="small"
                fullWidth
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                error={Boolean(amountError)}
                helperText={amountError}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth size="small" error={Boolean(bankError)}>
                <InputLabel id="bank-transfer-label">
                  {language === 'TH' ? 'โอนจากธนาคาร' : 'Transfer from Bank'}
                </InputLabel>
                <Select
                  labelId="bank-transfer-label"
                  id="bank-transfer"
                  label={
                    language === 'TH' ? 'โอนจากธนาคาร' : 'Transfer from Bank'
                  }
                  value={bank}
                  onChange={(e) => setBank(e.target.value)}
                  renderValue={(selected) => (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <img
                        src={
                          bankOptions.find(
                            (option) => option.label === selected,
                          )?.icon
                        }
                        alt={selected}
                        style={{
                          width: 20,
                          height: 20,
                          marginRight: 8,
                          borderRadius: '50%',
                          objectFit: 'cover',
                        }}
                      />
                      {selected}
                    </div>
                  )}
                >
                  {bankOptions.map(({ label, value, icon }) => (
                    <MenuItem key={value} value={label}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img
                          src={icon}
                          alt={label}
                          style={{
                            width: 30,
                            height: 30,
                            marginRight: 20,
                            borderRadius: '50%',
                            objectFit: 'cover',
                          }}
                        />
                        <ListItemText primary={label} />
                      </div>
                    </MenuItem>
                  ))}
                </Select>
                {bankError && (
                  <Typography variant="caption" color="error">
                    {bankError}
                  </Typography>
                )}
              </FormControl>
            </Grid>

            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Grid item xs={12} md={6}>
                <MobileDatePicker
                  label={language === 'TH' ? 'วันที่โอนเงิน' : 'Transfer Date'}
                  inputFormat="MM/dd/yyyy"
                  maxDate={new Date()}
                  value={date}
                  onChange={(newValue) => setDate(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      size="small"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton>
                              <CalendarMonthIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <MobileTimePicker
                  label={language === 'TH' ? 'เวลาที่โอนเงิน' : 'Transfer Time'}
                  value={time}
                  onChange={(newValue) => setTime(newValue)}
                  ampm={false}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      size="small"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton>
                              <AccessTimeIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>

              {images.length > 0 && (
                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      flexDirection: 'column',
                    }}
                  >
                    {images.map((image, index) => (
                      <Box
                        key={index}
                        sx={{
                          position: 'relative',
                          marginBottom: '10px',
                        }}
                      >
                        <img
                          src={URL.createObjectURL(image)}
                          alt={`Proof ${index + 1}`}
                          style={{
                            width: '100%',
                            height: 'auto',
                            maxWidth: '300px',
                            borderRadius: '8px',
                          }}
                        />
                        <IconButton
                          sx={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            color: '#fffffff',
                          }}
                          onClick={() => handleRemoveImage(index)}
                        >
                          <ClearIcon />
                        </IconButton>
                      </Box>
                    ))}
                  </Box>
                </Grid>
              )}

              <Grid item xs={12}>
                <input
                  accept="image/png, image/jpeg, image/gif"
                  type="file"
                  multiple
                  onChange={handleImageChange}
                  style={{ display: 'none' }}
                  id="upload-file"
                />
                <label htmlFor="upload-file">
                  <Button
                    variant="contained"
                    component="span"
                    sx={{ width: '100%', marginTop: '16px' }}
                  >
                    {language === 'TH'
                      ? 'อัพโหลดไฟล์รูป'
                      : 'Upload Image Files'}
                  </Button>
                </label>
                {imageError && (
                  <Typography variant="caption" color="error">
                    {imageError}
                  </Typography>
                )}
                <Typography variant="caption" color="textSecondary">
                  {language === 'TH'
                    ? 'สามารถอัพโหลดได้ไม่เกิน 5 รูป'
                    : 'You can upload up to 5 images'}
                </Typography>
              </Grid>
            </LocalizationProvider>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              gap: 2,
              marginBottom: '40px',
            }}
          >
            <Button
              onClick={onClose}
              sx={{
                width: '100px',
                border: '1px solid',
                color: '#FC3A3A',
                backgroundColor: 'transparent',
                '&:hover': { backgroundColor: 'rgba(252, 58, 58, 0.1)' },
              }}
            >
              {language === 'TH' ? 'ยกเลิก' : 'Cancel'}
            </Button>
            <Button
              onClick={handleConfirmationOpen}
              sx={{
                width: '100px',
                border: '1px solid ',
                color: '#51D245',
                backgroundColor: 'transparent',
                '&:hover': { backgroundColor: 'rgba(81, 210, 69, 0.1)' },
              }}
            >
              {language === 'TH' ? 'ยืนยัน' : 'Confirm'}
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
      <ConfirmationPopup
        open={confirmationOpen}
        onClose={() => setConfirmationOpen(false)}
        onConfirm={handleFinalConfirmationOpen}
        amount={amount}
        bank={bank}
        transferDate={formattedDate}
        transferTime={formattedTime}
        images={images}
        language={language}
      />
      <FinalConfirmationPopup
        open={finalConfirmationOpen}
        onClose={() => setFinalConfirmationOpen(false)}
        language={language}
      />
    </>
  );
}

export default BankTransferPopup;
